var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('video',{attrs:{"autoplay":"","controls":"","playsinline":"true","loop":"","muted":"true"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.acredoVideoUrl + _vm.videoSetId + '.mp4',"type":"video/mp4"}}),_vm._v("\n    "+_vm._s(_vm.$t('pages.item.item3d.browserSupport'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }